import { ButtonProps as MuiButtonProps } from "@mui/material";
import React from "react";
import { useHistory } from "react-router-dom";
import { ButtonSpinner, StyledButton } from "./style";

export interface ButtonProps extends MuiButtonProps {
	backgroundColor?: string;
	hoverBackgroundColor?: string;
	hover?: boolean;
	link?: string;
	replace?: boolean;
	disabledShadow?: boolean;
	loading?: boolean;
	height?: number;
}

export default function Button({
	onClick,
	backgroundColor,
	link,
	replace,
	variant,
	disabledShadow,
	children,
	loading,
	height,
	...args
}: ButtonProps) {
	const history = useHistory();

	const handleClickButton = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		if (onClick) {
			onClick(e);
		}

		if (link) {
			if (replace) {
				history.replace(link);
			} else {
				history.push(link);
			}
		}
	};

	const getVariant = () => {
		if (backgroundColor && !variant) {
			return "contained";
		}

		return variant;
	};

	return (
		<StyledButton
			type="submit"
			onClick={handleClickButton}
			variant={getVariant()}
			backgroundColor={backgroundColor}
			disabledShadow={disabledShadow}
			height={height}
			{...args}
		>
			{loading ? <ButtonSpinner size={height ? height / 2 : 20} /> : children}
		</StyledButton>
	);
}
